export default "__VITE_ASSET__92b403c6__"